import React from "react";

import { sizes } from "@/components/ui/Spinner/utils";

import cn from "@/utils/cn";

import styles from "./style.module.css";

type SpinnerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: keyof typeof sizes;
};

export const Spinner = ({
  size = "md",
  className = "",
  ...props
}: SpinnerProps) => {
  const spinner = sizes[size];
  const center = spinner.size / 2;
  const radius = spinner.size / 2 - spinner.stroke / 2;
  const circumference = 2 * Math.PI * radius * 1.2;
  const cssVars = {
    "--circumference": circumference,
    "--quarter": circumference / 4,
  } as React.CSSProperties;

  return (
    <div
      className={cn("inline-block text-chorus-black-100", className)}
      style={cssVars}
      data-testid="spinner"
      {...props}
    >
      <svg
        width={spinner.size}
        height={spinner.size}
        viewBox={`0 0 ${spinner.size} ${spinner.size}`}
        xmlns="http://www.w3.org/2000/svg"
        data-testid="spinner-svg"
      >
        <circle
          fill="none"
          className={cn(styles.path)}
          strokeWidth={spinner.stroke}
          strokeLinecap="square"
          stroke="currentColor"
          cx={center}
          cy={center}
          r={radius}
        ></circle>
      </svg>
    </div>
  );
};
